<template>
  <div class="about">
    <a href="#" @click.prevent="onClick" class="about__switcher" :class="{'--active': isActive}">О проекте</a>
    <p class="about__text" :class="{'--active': isActive}">
      Партнёр коммерческого проекта ПАО «МегаФон» © 2019<br>
      Все права защищены © АО Бизнес Ньюс Медиа, 1999—2019
    </p>
  </div>
</template>
<script>
  export default {
    name: 'About',
    data() {
      return {
        isActive: false
      }
    },
    methods: {
      onClick() {
        this.isActive = !this.isActive
      }
    }
  }
</script>
<style lang="scss">
  .about {
    background: #fbede5;

    &__switcher {
      height: 14px;
      line-height: 14px;
      font-size: 14px;
      color: #00b956;
      padding-left: 17px;

      text-decoration: none;
      display: inline-block;
      vertical-align: top;
      position: relative;
      &::before {
        content: '';
        width: 9px;
        height: 14px;
        position: absolute;
        left: 0;
        top: 0;
        background: url(../assets/arrow.svg) no-repeat center center;
        transition: transform .2s ease-in-out;
      }
      &.--active::before {
        transform: rotate(90deg);
      }
    }

    &__text {
      max-height: 0;
      transition: max-height .2s ease-in-out;
      overflow: hidden;
      height: 100%;
      line-height: 18px;
      font-size: 12px;
      margin: 10px 0 10px;
      padding: 0;
      &.--active {
        max-height: 72px;
      }
    }
  }
</style>
